// import { RunWorkH5 } from "@runwork/runwork-help";
// import { RUNWORK_HELP_OPTION } from "@/constant/index.js";
// const downloadUrl =
//   "https://runwork-h5.crc.com.cn/runwork-download-mobile/?appKey=app-16#/";
// if (window.h5sdk !== undefined) {
//   const runworkH5 = new RunWorkH5(RUNWORK_HELP_OPTION);
//   runworkH5
//     .jssdkReady()
//     .then(() => {
//       window.tt.openSchema({
//         schema: downloadUrl,
//         external: true,
//         success(res) {
//           console.log("openSchema success", res);
//           if (/iphone/gi.test(window.navigator.userAgent) === false) {
//             setTimeout(() => {
//               claseApp();
//             }, 1500);
//             return;
//           }
//           claseApp();
//         },
//         fail(res) {
//           console.log(`openSchema fail: ${res}`);
//         },
//       });
//     })
//     .catch((e) => {
//       console.error("初始化失败", e);
//     });
// } else {
//   location.replace(downloadUrl);
// }

// function claseApp() {
//   window.h5sdk.biz.navigation.close({
//     onSuccess: function(result) {
//       console.log(result);
//     },
//   });
// }

window.location.replace("https://runwork-h5.crc.com.cn/runwork-download-mobile/?appKey=app-16#/");